import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, resolveMediaUrl } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function Profile() {
  const { user, refresh } = useAuth();
  const { t } = useLanguage();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadPosts = async () => {
    setLoading(true);
    try {
      const response = await api.get('/getUserPosts');
      setPosts(response.data || []);
    } catch (err) {
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    loadPosts();
  }, []);

  const avatar = resolveMediaUrl(user?.userImage);
  const workoutPlan = user?.workoutPlan || {};
  const formatDay = (value) => {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  };

  return (
    <div className="list">
      <div className="card">
        <div style={{ display: 'flex', gap: 18, alignItems: 'center' }}>
          <div className="brand-mark">{user?.nickName?.slice(0, 1)?.toUpperCase() || 'A'}</div>
          {avatar ? <img src={avatar} alt="avatar" style={{ width: 72, height: 72, borderRadius: 20 }} /> : null}
          <div>
            <h2 className="section-title" style={{ margin: 0 }}>{user?.name} {user?.surname}</h2>
            <div className="muted">@{user?.nickName}</div>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <Link className="btn btn-ghost" to="/profil/duzenle">{t('profile.edit')}</Link>
          </div>
        </div>
      </div>

      <div className="grid two-col">
        <div className="card">
          <h3 className="section-title">{t('profile.currentPlan')}</h3>
          <div className="list">
            {Object.keys(workoutPlan).length ? (
              Object.entries(workoutPlan).map(([day, muscles]) => (
                <div key={day} className="card" style={{ background: 'rgba(15,23,42,0.6)' }}>
                  <strong>{formatDay(day)}</strong>
                  <p className="muted">{(muscles || []).join(', ') || t('profile.emptyDay')}</p>
                </div>
              ))
            ) : (
              <p className="muted">{t('profile.noProgram')}</p>
            )}
          </div>
        </div>
        <div className="card">
          <h3 className="section-title">{t('profile.info')}</h3>
          <div className="list">
            <div className="card" style={{ background: 'rgba(15,23,42,0.6)' }}>
              <span className="muted">{t('profile.email')}</span>
              <div>{user?.email}</div>
            </div>
            <div className="card" style={{ background: 'rgba(15,23,42,0.6)' }}>
              <span className="muted">{t('profile.heightWeight')}</span>
              <div>{user?.height || '-'} cm · {user?.weight || '-'} kg</div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <h3 className="section-title">{t('profile.posts')}</h3>
        {loading ? <p className="muted">{t('common.loading')}</p> : null}
        <div className="post-grid">
          {posts.map((post) => {
            const mediaUrl = resolveMediaUrl(post.mediaType === 'video' ? post.video : post.image);
            return (
              <div key={post._id} className="post-card">
                {post.mediaType === 'video' ? (
                  <video src={mediaUrl} controls />
                ) : (
                  <img src={mediaUrl} alt="post" />
                )}
                <div style={{ padding: 12 }}>
                  <div>{post.description}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
